module.exports = __webpack_public_path__ + "static/media/de_cache.2cb08b4b.jpg";